import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, EnumDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { Address } from '../addresses/Address.js';
import { Gender } from '../members/Gender.js';
import { PaymentCustomer } from '../PaymentCustomer.js';
export class Customer extends AutoEncoder {
    firstName = '';
    lastName = '';
    email = '';
    phone = '';
    birthDay = null;
    address = null;
    gender = Gender.Other;
    get name() {
        if (this.lastName === '') {
            return this.firstName;
        }
        if (this.firstName === '') {
            return this.lastName;
        }
        return this.firstName + ' ' + this.lastName;
    }
    toPaymentCustomer() {
        return PaymentCustomer.create({
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            phone: this.phone,
        });
    }
}
__decorate([
    field({ decoder: StringDecoder })
], Customer.prototype, "firstName", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Customer.prototype, "lastName", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Customer.prototype, "email", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Customer.prototype, "phone", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true, version: 403 })
], Customer.prototype, "birthDay", void 0);
__decorate([
    field({ decoder: Address, nullable: true, version: 403 })
], Customer.prototype, "address", void 0);
__decorate([
    field({ decoder: new EnumDecoder(Gender), defaultValue: () => Gender.Other, isDefaultValue: v => v === Gender.Other, version: 403 })
], Customer.prototype, "gender", void 0);
//# sourceMappingURL=Customer.js.map